import {
  ChangeDetectorRef,
  Component, EventEmitter, Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  BaseSiteService,
  CmsService, GlobalMessageService,
  GlobalMessageType,
  LanguageService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { CustomRegistrationService } from '../../custom-registration.service';
import {
  delTimeValue, globalErrorMsgEng,
  globalErrorMsgFr,
  siteLanguagesEng
} from '../../registration.constants';

const specificCharsNotAllowed = '[^!$%*()=]+$';

@Component({
    selector: 'app-billing-information',
    templateUrl: './billing-information.component.html',
    styleUrls: ['./billing-information.component.scss'],
    standalone: false
})
export class BillingInformationComponent implements OnInit, OnDestroy {
  @Input() formDetails: any;
  @Input() multipleFormData: FormGroup[];
  @Output() shippingDataSet = new EventEmitter<any>();

  mondaydelFromTime: number;
  mondaydelToTime: number;
  extensionErrorMsg: boolean = false;
  billingFormForPostalCode: FormGroup;
  timelist = delTimeValue;
  nodeliveryTime: boolean;
  cmsResponse: any;
  finalNeedAss: any;
  billingForm: FormGroup;
  provinces: any[] = [];
  practiceOrFacility: any[] = [];
  orderCreationPlans: any[] = [];
  yellowFever: boolean[] = [true, false];
  isShippingAddressSame: boolean[] = [true, false];
  errorMessageText: string = globalErrorMsgEng;
  provinceSub: Subscription;
  captchaResp: any;
  practiceOrFacilitySub: Subscription;
  userOrderPlanSub: Subscription;


  emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  displayMondayError: boolean;
  displayTuesError: boolean;
  displayWedError: boolean;
  displayThursError: boolean;
  displayFriError: boolean;
  baseSiteId: any;
  creditInvoice: string;
  header: string;
  emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly user: UserAccountFacade,
    private readonly router: Router,
    private readonly languageService: LanguageService,
    private readonly globalMessage: GlobalMessageService,
    private baseSiteService: BaseSiteService,
    private readonly cmsData: CmsService,
    private _dataLayerService: DataLayerService
  ) { }

  ngOnInit(): void {
    this.header = 'billingDetails';
    this.creditInvoice = 'invoiceTable';

    this.accountRegService.sectionChange.subscribe((sectionDetails) => {
      this.header = sectionDetails.header;
      this.cdr.detectChanges();
    });

    localStorage.setItem("section", "Shipping");

    window.scroll(0, 0);
    this.baseSiteService.getActive().pipe(take(1)).subscribe((res) => (this.baseSiteId = res));

    this.finalNeedAss =  this.cmsData.getComponentData('NeedAssistanceComponent');

    this.languageService.getActive().subscribe((langRes) => {
      this.errorMessageText =
        langRes === siteLanguagesEng ? globalErrorMsgEng : globalErrorMsgFr;
    });
    this.accountRegService.getProvinces({
      fields: 'DEFAULT',
    });
    this.accountRegService.getPracticeOrFacilityType({
      enumerationType: 'PracticeOrFacilityType',
      fields: 'DEFAULT',
    });
    this.accountRegService.getContactOrderPlan({
      enumerationType: 'CreateOrderPlan',
      fields: 'DEFAULT',
    });
    const maxlengthChar = 256;
    const charlengthSix = 6;
    const maxlengthTwelve = 12;
    const maxlengthEight = 8;
    const maxlengthFourty = 40;


    this.billingForm = new FormGroup({
      billingAddress: new FormGroup({
        facilityName: new FormControl(null, [
          Validators.required,
          Validators.pattern(specificCharsNotAllowed),
          Validators.maxLength(maxlengthFourty),
        ]),
        facilityName2: new FormControl(null, [
          Validators.pattern(specificCharsNotAllowed),
          Validators.maxLength(maxlengthFourty),
        ]),
        attention: new FormControl(null, [
          Validators.pattern(specificCharsNotAllowed),
          Validators.maxLength(maxlengthChar),
        ]),
        line1: new FormControl(null, [
          Validators.required,
          Validators.pattern(specificCharsNotAllowed),
          Validators.maxLength(maxlengthChar),
        ]),
        line2: new FormControl(null, [
          Validators.pattern(specificCharsNotAllowed),
          Validators.maxLength(maxlengthChar),
        ]),
        town: new FormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z ]+$'),
          Validators.maxLength(maxlengthChar),
        ]),
        region: new FormGroup({
          isocode: new FormControl(null, Validators.required),
          countryIso: new FormControl('CA'),
          name: new FormControl(null),
        }),
        postalCode: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$'),
          Validators.maxLength(10),
        ]),
        phone: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
          Validators.maxLength(maxlengthTwelve),
        ]),
        extension: new FormControl(null, [
          Validators.pattern('[0-9]*$'),
          Validators.maxLength(charlengthSix),
        ]),
        email: new FormControl(null, [
          Validators.required,



          Validators.pattern(this.emailRegx),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        confirmEmail: new FormControl(null, [
          Validators.required,



          Validators.pattern(this.emailRegx),
          Validators.minLength(charlengthSix),
          Validators.maxLength(maxlengthChar),
        ]),
        practiceOrFacilityType: new FormControl(null, Validators.required),
        orderCreationPlan: new FormControl(null, [Validators.required]),
        contractGroupName: new FormControl(null, [Validators.required]),
        yellowFever: new FormControl(this.yellowFever[1]),
        billingAddress: new FormControl(this.isShippingAddressSame[0]),
        shippingAddress: new FormControl(this.isShippingAddressSame[1]),


        mondayFromTime: new FormControl(null),
        mondayToTime: new FormControl(null),
        tuesFromTime: new FormControl(null),
        tuesToTime: new FormControl(null),
        wedFromTime: new FormControl(null),
        wedToTime: new FormControl(null),
        thursFromTime: new FormControl(null),
        thursToTime: new FormControl(null),
        fridayFromTime: new FormControl(null),
        fridayToTime: new FormControl(null),
      }),
    });








    if (localStorage.getItem("billingFormDetails") != null) {

      const formVals = JSON.parse(localStorage.getItem("billingFormDetails"));


      this.billingForm.patchValue(
        {
          billingAddress: {
            facilityName: formVals.facilityName,
            facilityName2: formVals.facilityName2,
            attention: formVals.attention,
            line1: formVals.line1,
            line2: formVals.line2,
            town: formVals.town,
            region: {
              isocode: formVals.region.isocode,
              name: formVals.region.name,
            },
            postalCode: formVals.postalCode,
            phone: formVals.phone,
            extension: formVals.extension,
            fax: formVals.fax,
            email: formVals.email,
            confirmEmail: formVals.confirmEmail,
            practiceOrFacilityType:
              formVals.practiceOrFacilityType,
            yellowFever: formVals.yellowFever,

            billingAddress: formVals.billingAddress,
            shippingAddress: formVals.shippingAddress,
            mondayFromTime: formVals.mondayFromTime ? formVals.mondayFromTime : new FormControl(null),
            mondayToTime: formVals.mondayToTime ? formVals.mondayToTime : new FormControl(null),
            tuesFromTime: formVals.tuesFromTime ? formVals.tuesFromTime : new FormControl(null),
            tuesToTime: formVals.tuesToTime ? formVals.tuesToTime : new FormControl(null),
            wedFromTime: formVals.wedFromTime ? formVals.wedFromTime : new FormControl(null),
            wedToTime: formVals.wedToTime ? formVals.wedToTime : new FormControl(null),
            thursFromTime: formVals.thursFromTime ? formVals.thursFromTime : new FormControl(null),
            thursToTime: formVals.thursToTime ? formVals.thursToTime : new FormControl(null),
            fridayFromTime: formVals.fridayFromTime ? formVals.fridayFromTime : new FormControl(null),
            fridayToTime: formVals.fridayToTime ? formVals.fridayToTime : new FormControl(null),
          },
        },
        { emitEvent: false }
      );
    }
    this.provinceSub = this.accountRegService.provinceData$.subscribe((res) => {
      if (res !== false) {
        this.provinces = res?.regions;
      }
      this.cdr.detectChanges();
    });

    this.practiceOrFacilitySub =
      this.accountRegService.practiceOrFacilityTypeData$.subscribe(
        (response) => {
          if (response !== false) {
            this.practiceOrFacility = response;
          }
        }
      );

    this.userOrderPlanSub = this.accountRegService.contactOrderPlanData$.subscribe(
      (response) => {
        if (response !== false) {
          this.orderCreationPlans = response;
        }
      }
    );
    this.cdr.detectChanges();

    this.billingForm.valueChanges.subscribe((res) => {

      if (res.billingAddress.mondayToTime !== "") {
        this.displayMondayError = false
      }
      if (res.billingAddress.tuesToTime !== "") {
        this.displayTuesError = false
      }
      if (res.billingAddress.wedToTime !== "") {
        this.displayWedError = false
      }
      if (res.billingAddress.thursToTime !== "") {
        this.displayThursError = false
      }
      if (res.billingAddress.fridayToTime !== "") {
        this.displayFriError = false
      }
    })

    this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_start', 'shipping');
    this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_step', 'shipping');
  }
  validationExtension(e) {
    if (e?.length > 6) {
      this.extensionErrorMsg = true;
      setTimeout(() => {
        this.extensionErrorMsg = false;
      }, 1000);
    }
    else {
      this.extensionErrorMsg = false;
    }

  }
  proceedToShipping() {
    this.checkBlankDeliveryTime()
    if (this.billingForm.value.billingAddress.mondayFromTime === null && this.billingForm.value.billingAddress.mondayToTime === null && this.billingForm.value.billingAddress.tuesFromTime === null && this.billingForm.value.billingAddress.tuesToTime === null && this.billingForm.value.billingAddress.wedFromTime === null && this.billingForm.value.billingAddress.wedToTime === null && this.billingForm.value.billingAddress.thursFromTime === null && this.billingForm.value.billingAddress.thursToTime === null && this.billingForm.value.billingAddress.fridayFromTime === null && this.billingForm.value.billingAddress.fridayToTime == null) {
      this.nodeliveryTime = true;
      this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'shipping', 'tab');
    }
    else {
      this.billingForm.markAllAsTouched();
      if (this.billingForm.valid &&
        this.billingForm.get('billingAddress.email').value.toLowerCase() ===
        this.billingForm.get('billingAddress.confirmEmail').value.toLowerCase() &&
        !(this.displayMondayError || this.displayTuesError || this.displayWedError || this.displayThursError || this.displayFriError)
      ) {
        this.nodeliveryTime = false;



        if (!!this.multipleFormData && this.multipleFormData.length > 0) {
          this.multipleFormData[0] = this.billingForm;
        } else {
          this.multipleFormData = [];
        }
        const billingDetails = {
          header: 'shippingDetails',
          form: this.billingForm,
          forms: this.multipleFormData,
        };

        let found = this.provinces.find(e => e.isocode === this.billingForm.value.billingAddress.region.isocode);

        if (found !== undefined) {
          this.billingForm.patchValue(
            {
              billingAddress: {
                region: {
                  name: found.name != null ? found.name : "",
                },
              }
            });
          localStorage.setItem("billingFormDetails", JSON.stringify(this.billingForm.value.billingAddress));
        }



















        this.shippingDataSet.emit(billingDetails);
        this.accountRegService.sectionChange.next(billingDetails);



      } else {
        window.scroll(0, 0);
        this.globalMessage.add(
          this.errorMessageText,
          GlobalMessageType.MSG_TYPE_ERROR
        );
        this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'shipping', 'tab');
      }
    }

  }
  checkBlankDeliveryTime() {
    if (this.billingForm.value.billingAddress.mondayFromTime !== "" && this.billingForm.value.billingAddress.mondayToTime === "") {
      this.displayMondayError = true;
    } else {
      this.displayMondayError = false;
    }
    if (this.billingForm.value.billingAddress.tuesFromTime !== "" && this.billingForm.value.billingAddress.tuesToTime === "") {
      this.displayTuesError = true;
    } else {
      this.displayTuesError = false;
    }
    if (this.billingForm.value.billingAddress.wedFromTime !== "" && this.billingForm.value.billingAddress.wedToTime === "") {
      this.displayWedError = true;
    } else {
      this.displayWedError = false;
    }
    if (this.billingForm.value.billingAddress.thursFromTime !== "" && this.billingForm.value.billingAddress.thursToTime === "") {
      this.displayThursError = true;
    } else {
      this.displayThursError = false;
    }
    if (this.billingForm.value.billingAddress.fridayFromTime !== "" && this.billingForm.value.billingAddress.fridayToTime === "") {
      this.displayFriError = true;
    } else {
      this.displayFriError = false;
    }

  }
  resolved(captchaResponse: string) {

    this.captchaResp = captchaResponse;

  }
  changeDeliverTime(event, opName, currName, fromToVal) {
    this.nodeliveryTime = false;
    if (fromToVal === 'to') {
      let text = currName.replace('ToTime', '');


      if (this.billingForm.get(`billingAddress.${opName}`).value == null) {
        this.billingForm.get(`billingAddress.${currName}`).setValue('');
        document.getElementById(text + "Btn").click();
      }

      else if (this.billingForm.get(`billingAddress.${opName}`).value >= event) {
        this.billingForm.get(`billingAddress.${currName}`).setValue('');
        document.getElementById(text + "Btn").click();

      }
      else {
        this.billingForm.get(`billingAddress.${currName}`).setValue(event);
      }
    }
    if (event === 1 || event === 2) {
      if (fromToVal === 'to' && this.billingForm.get(`billingAddress.${opName}`).value !== 1 &&
        this.billingForm.get(`billingAddress.${opName}`).value !== 2) {

        this.billingForm.get(`billingAddress.${currName}`).setValue('');
      } else {
        this.billingForm.get(`billingAddress.${opName}`).setValue(event);
      }
    } else if (fromToVal === 'from') {
      this.billingForm.get(`billingAddress.${currName}`).setValue(event);
      this.billingForm.get(`billingAddress.${opName}`).setValue('');
      let text = currName.replace('FromTime', '');


    }



  }
  ngOnDestroy() {
    this.practiceOrFacilitySub?.unsubscribe();
    this.provinceSub?.unsubscribe();
    this.userOrderPlanSub?.unsubscribe();
  }

  onAddress(place: google.maps.places.PlaceResult) {
    var streetNumber: string;
    var route: string;
    var locality: string;
    var country: string;
    var postalCode: string;
    var subpremise: string;
    var neighborhood: string;
    var sublocality: string;
    var adminArea: string;
    var postalSuffix: string;

    const components = place.address_components;
    components.forEach((component) => {
      if (component.types.includes('street_number')) streetNumber = component.long_name || '';
      else if (component.types.includes('route'))  route = component.long_name || '';
      else if (component.types.includes('subpremise'))  subpremise = component.long_name || '';
      else if (component.types.includes('neighborhood'))  neighborhood = component.long_name || '';
      else if (component.types.includes('sublocality'))  sublocality = component.long_name || '';
      else if (component.types.includes('locality'))  locality = component.long_name || '';
      else if (component.types.includes('administrative_area_level_1'))  adminArea = component.short_name || '';
      else if (component.types.includes('country'))  country = component.short_name || '';
      else if (component.types.includes('postal_code'))  postalCode = component.long_name || '';
      else if (component.types.includes('postal_code_suffix'))  postalSuffix = component.long_name || '';
    });
    if (! streetNumber &&  route) {
      const match =  route.match(/^(\d+)\s+(.*)/);
      if (match) {
        streetNumber = match[1];
        route = match[2] || '';
      }
    }
  
    let line1 = [ streetNumber,  route].filter(Boolean).join(' ').toUpperCase() || '';
    let line2 =  subpremise ?  subpremise.toUpperCase() : '';
    let town = ( neighborhood ||  sublocality ||  locality || '').toUpperCase();
    let fullPostalCode =  postalSuffix ? `${postalCode}-${postalSuffix}` :  postalCode || '';
    let regionIso =  country &&  adminArea ? `${ country}-${ adminArea}`.toUpperCase() : '';

    this.billingForm.controls.billingAddress.get('line1')?.setValue(line1);
    this.billingForm.controls.billingAddress.get('line2')?.setValue(line2);
    this.billingForm.controls.billingAddress.get('town')?.setValue(town);
    this.billingForm.controls.billingAddress.get('postalCode')?.setValue(fullPostalCode);
    this.billingForm.controls.billingAddress.get('region.isocode')?.setValue(regionIso);
  }
}
